import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { DashboardGuard } from "./dashboard/DashboardGuard";
import { DashboardLayout } from "./dashboard/DashboardLayout";
import { BookPage } from "./pages/BookPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AvailabilityPage } from "./pages/AvailabilityPage";
import { EventTypesPage } from "./pages/EventTypesPage";
import { HomePage } from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { ManageBookingPage } from "./pages/ManageBookingPage";
import { PrivacyPage } from "./pages/PrivacyPage";

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/book/:eventSlug" element={<BookPage />} />
        <Route path="/manage/:token" element={<ManageBookingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route element={<DashboardGuard />}>
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="availability" element={<AvailabilityPage />} />
            <Route path="event-types" element={<EventTypesPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
